import { render, staticRenderFns } from "./VehicleAveragePriceAI.vue?vue&type=template&id=62be339e&"
import script from "./VehicleAveragePriceAI.vue?vue&type=script&lang=js&"
export * from "./VehicleAveragePriceAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports